import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AccountStateService, AppStorageService, AuthService, NavigationStateService } from '@mwe/services';

@Component({
  selector: 'mwe-collaboration-entry',
  template: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CollaborationEntryComponent implements OnInit {
  readonly appStorage = inject(AppStorageService);
  readonly authService = inject(AuthService);
  readonly accountStateService = inject(AccountStateService);
  readonly route = inject(ActivatedRoute);
  readonly navigationStateService = inject(NavigationStateService);

  ngOnInit(): void {
    this.accountStateService.clearBeforeCollaboration();
    this.appStorage.clear();
    this.navigationStateService.setInitialUrl(this.route.snapshot.queryParamMap.get('redirect'));
    this.authService.login();
  }
}
